export const parseShopifyHost = () => {
    // Safety check for SSR
    if (typeof window === 'undefined') {
        return { shopName: null, isShopifyApp: false };
    }

    const { host, search } = window.location;
    const shopParam = new URLSearchParams(search).get('shop');
    return {
        shopName: shopParam || "",
        isShopifyApp: host.includes('apps.shopify.com') || !!shopParam
    };
};